// Curations — explicitly punted to a follow-up plan. This placeholder
// reserves the nav slot so the editor sees the full eventual surface.
import { Card, CardSubtle, CardTitle } from "../../components/ui/Card";

export default function CurationsPage() {
  return (
    <div>
      <h1 style={{ fontSize: 22, fontWeight: 700, margin: "0 0 16px" }}>
        Curations
      </h1>
      <Card>
        <CardTitle>Coming after launch</CardTitle>
        <CardSubtle>
          Editor-curated packages for News, Recipes, Lifestyle, and Events
          feeds. Drag-and-drop ordering, autofill rules, and component
          presets (Hero, ThreeUp, Carousel, Pair, List). Tracked separately
          from this round.
        </CardSubtle>
      </Card>
    </div>
  );
}
